import React from 'react';
import { SvgIcon } from '../components/svgIcon';
import { SvgIconProps } from '../components/svgIcon/model';

export const SearchIcon = React.forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => {
  return (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    <SvgIcon cacheName="search" ref={ref as any} {...props}>
      <path
        d="M19.7844 18.7443L16.0185 14.9785C16.9491 13.8209 17.5072 12.3514 17.5072 10.7539C17.5072 7.02965 14.4777 4 10.7537 4C7.02955 4 4 7.02965 4 10.7539C4 14.4778 7.02956 17.5072 10.7537 17.5072C12.3511 17.5072 13.8207 16.9492 14.9782 16.0185L18.7443 19.7845V19.7846C18.8878 19.9282 19.0764 20 19.2643 20C19.4524 20 19.6409 19.9282 19.7845 19.7846C20.0718 19.4973 20.0718 19.0315 19.7845 18.7443C19.7844 18.7443 19.7844 18.7443 19.7844 18.7443ZM5.47115 10.7539C5.47115 7.84106 7.84097 5.47115 10.7537 5.47115C13.6662 5.47115 16.036 7.84105 16.036 10.7539C16.036 13.6664 13.6662 16.036 10.7537 16.036C7.84096 16.036 5.47115 13.6664 5.47115 10.7539Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
});
